module.exports = __webpack_public_path__ + "media/images/svg/clients/20-91e3235877de7172a12ffa9b77d20dbd.svg";